class RefundTransactionService {
  constructor(client) {
    this.apiClient = client;
  }

  async searchRefundTransactions(searchParams, cancelToken) {
    return await this.apiClient.post(
      `refundsearch/refundabletickets`,
      searchParams,
      {
        headers: { "Content-Type": "application/json" },
      },
      cancelToken
    );
  }

  async requestRefund(requestRefund) {
    return await this.apiClient.post(
      `refundpayment/requestrefund`,
      requestRefund,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  }
}

export default RefundTransactionService;
